import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Site, SiteImages } from '@/types/site.types'
import { fetchSiteImages, fetchSites } from './sitesThunks'

interface SitesState {
  sites: Site[]
  images: SiteImages[]
  loading: boolean
  error: string | null
}

const initialState: SitesState = {
  sites: [],
  images: [],
  loading: false,
  error: null,
}

const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    clearSitesError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSites.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSites.fulfilled, (state, action: PayloadAction<Site[]>) => {
        state.loading = false
        state.sites = action.payload
      })
      .addCase(fetchSites.rejected, (state, action: any) => {
        state.loading = false
        state.error = action.payload || action.error?.message || 'Failed to load sites'
      })

      .addCase(fetchSiteImages.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSiteImages.fulfilled, (state, action: PayloadAction<SiteImages[]>) => {
        state.loading = false
        state.images = action.payload
      })
      .addCase(fetchSiteImages.rejected, (state, action: any) => {
        state.loading = false
        state.error = action.payload || action.error?.message || 'Failed to load sites'
      })
  },
})

export const { clearSitesError } = sitesSlice.actions
export default sitesSlice.reducer
